/**
 * Filtrar um formulario oriundo de "serializeArray" (JQuery) para facilitar a leitura e a manipulacao
 */
jQuery.fn.retornarDadosFormulario = function() {
  return $(this)
    .serializeArray()
    .reduce((_retorno, _item) => {
      const _indexItemOpcao = _retorno.findIndex(_i => _i.name == _item.name);

      if (typeof _item.value == "string" && _item.value.isJson()) {
        _item.value = JSON.parse(_item.value);
      }

      if (_indexItemOpcao >= 0) {
        if (Array.isArray(_retorno[_indexItemOpcao].value)) {
          _retorno[_indexItemOpcao].value.push(_item.value);
        } else {
          _retorno[_indexItemOpcao].value = [
            _retorno[_indexItemOpcao].value,
            _item.value
          ];
        }
      } else {
        _retorno.push(_item);
      }

      return _retorno;
    }, []);
};

/**
 * Validar se a string é um json
 */
String.prototype.isJson = function() {
  try {
    JSON.parse(this);
  } catch (e) {
    return false;
  }

  return true;
};

/**
 * Validar se a string é um e-mail válido
 */
String.prototype.isEmail = function() {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*$/.test(this);
};

/**
 * Escapa os caracteres especiais de um JSON
 */
// String.prototype.jsonEscape = function() {
//     return this.replace(/\\n/g, "\\n")
//                .replace(/\\'/g, "\\'")
//                .replace(/\\"/g, '\\"')
//                .replace(/\\&/g, "\\&")
//                .replace(/\\r/g, "\\r")
//                .replace(/\\t/g, "\\t")
//                .replace(/\\b/g, "\\b")
//                .replace(/\\f/g, "\\f");
// };
